import { useSyncExternalStore } from "react";
import { getProviderRuntimeStore } from "@/provider/ProviderRuntimeStore";
import type { ProviderRuntimeSnapshot } from "@/provider/ProviderTypes";

export function useProviderRuntimeSnapshot(): ProviderRuntimeSnapshot {
	const store = getProviderRuntimeStore();

	return useSyncExternalStore(
		(onStoreChange) => store.subscribe(() => onStoreChange()),
		() => store.getSnapshot(),
		() => store.getSnapshot()
	);
}